import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {StorageService} from "../services/storage/storage.service";

@Injectable({
  providedIn: 'root'
})
export class IsGuestGuard implements CanActivate {


  constructor(
    private storageService: StorageService,
    private router: Router,
  ) {
  }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log('GUARDIA IsLoggedGuard');
  //  let dati_utente = this.storageService.get('user');
    let token = this.storageService.get('token');
    console.log('token', token);


    if(token ){

      //console.log('GUARDIA IsGuestGuard - OK');
      this.router.navigateByUrl('/');
      return false;

    }else{

      //console.log('GUARDIA IsGuestGuard - KO');
      return true;

    }




  }

}
